// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
/**
 * Simple component that every `TeaserBoxInnerGrid` component
 * **HAS TO** import and use as a root element.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let InnerGridWrapper = class InnerGridWrapper extends Vue {
};
InnerGridWrapper = __decorate([
    Component({
        name: 'InnerGridWrapper',
        template: `
    <div class="teaser-box__inner-grid">
      <slot />
    </div>
  `
    })
], InnerGridWrapper);
export { InnerGridWrapper };
